import React, { Fragment } from 'react';
import { Form, Input, DatePicker } from 'antd';
import {
  dateFormat,
  start_date,
} from '../../../../../../common/utils/configFormField';
import locale from 'antd/lib/date-picker/locale/ru_RU';

const osagoExp = /^[а-я,А-Я]{3}\s?\d{10}$/i;
const Osago = ({ form, disabled }) => {
  const { getFieldDecorator } = form;
  return (
    <Fragment>
      <span className="label">Полис ОСАГО:</span>
      <Form.Item>
        {getFieldDecorator('osagoNum', {
            validateTrigger: 'onBlur',
            rules: [
              {
                validator: (rule, value, callback) => {
                    if (value && !value.match(osagoExp)) {
                        callback('Номер осаго должен быть формата AAA 0000000000')
                    } else {
                        callback()
                    }
                }
            }]
        })(
          <Input
            className="longInput"
            placeholder="Укажите номер полиса ОСАГО"
            disabled={disabled}
          />
        )}
      </Form.Item>
      <div className="validOsagoUntil">
        <span className="label">Действителен до:</span>
        <Form.Item>
          {getFieldDecorator('osagoValidUntilDate')(
            <DatePicker
              placeholder="Укажите дату"
              format={dateFormat}
              className="basicInput"
              disabledDate={start_date}
              disabled={disabled}
              locale={locale}
            />
          )}
        </Form.Item>
      </div>
    </Fragment>
  );
};

export default Osago;
